import { render, staticRenderFns } from "./WikiSlackConfig.vue?vue&type=template&id=42a06010"
import script from "./WikiSlackConfig.vue?vue&type=script&lang=ts"
export * from "./WikiSlackConfig.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports